import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spinner } from 'reactstrap';
import useInfiniteScroll from 'hooks/useInfiniteScroll';
import useDebouncedEffect from 'hooks/useDebounce';
import courseApi from 'api/courseApi';
import { LIMIT_COURSES_LEARNER, USER_METHODS } from 'constants/constants';
import {
  getCentresList,
  setSelectedCentre,
  getSelectedCentre,
  setCentresList,
} from 'store/master';

import ComponentSpinner from '@core/components/spinner/Loading-spinner';
import CourseItem from 'modules/Course/components/CourseItem';
// import LearnerItem from './LearnerItem';
import LearnerItem from './LearnerNew';
import { useUser, useViewMode } from 'hooks';
import DashboardHeader from './DashboardHeader';
import PermissionWrapper from '../../../components/Permission/PermissionWrapper';
import { useRouter } from 'next/router';
import getMonitorUrl from 'helpers/monitoring';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCartCountAsync,
  getWishListAsync,
  setPaymentPage,
} from 'store/cart';
import { getThemeColor } from 'store/settings';
import { handleToastError } from 'helpers';
const HomeLearner = () => {
  const { asPath } = useRouter();
  const selectedCentre = useSelector(getSelectedCentre);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const dispatch = useDispatch();
  const [search, setSearch] = useState('');
  const [courses, setCourses] = useState({
    data: [],
    currentPage: 0,
  });
  const themeStatus = useSelector(getThemeColor);
  const viewMode = useViewMode();
  const user = useUser();
  const [isBusy, setBusy] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching, hasMore, setHasMore] =
    useInfiniteScroll(fetchMoreListItems);

  useEffect(() => {
    if (user && metaData?.cmsHomePage) {
      dispatch(getCartCountAsync(user?._id));
      dispatch(getWishListAsync(user?._id));
      dispatch(setPaymentPage(false));
    }
  }, [user]);

  useEffect(() => {
    if (viewMode === 'LEARNER' && user?._id) {
      getMonitorUrl(user, viewMode, asPath);
    }
  }, [viewMode, user]);

  async function fetchMoreListItems(isReset = false) {
    try {
      const params = {
        page: isReset ? 1 : courses.currentPage + 1,
        rowPerPage: LIMIT_COURSES_LEARNER,
        textSearch: search,
        role: viewMode,
      };

      if (selectedCentre?._id) {
        params.courseCentre = selectedCentre?._id;
      }

      const payload = await courseApi.getList(params);

      setCourses((prevState) => ({
        ...payload,
        data: isReset ? payload.data : [...prevState.data, ...payload.data],
      }));

      if (payload.data.length < LIMIT_COURSES_LEARNER) {
        setHasMore(false);
      }
      setBusy(false);
      setIsFetching(false);
      setIsLoading(false);
    } catch (e) {
      handleToastError(e);
    }
  }

  const handleSearch = () => {
    setIsLoading(true);
  };

  useDebouncedEffect(
    () => {
      if (isBusy) return;
      setIsLoading(true);
    },
    500,
    [search],
  );

  // fetch data when isLoading = true
  useEffect(() => {
    if (!isLoading) return;
    fetchMoreListItems(true);
  }, [isLoading, selectedCentre]);

  return (
    <>
      <DashboardHeader onSearch={handleSearch} setSearch={setSearch} />
      {!isLoading ? (
        <>
          <PermissionWrapper
            permissions={[[USER_METHODS.GET, 'courses', viewMode]]}
            msgNoPermission={"You don't have permission to view content."}
          >
            <div>
              <LearnerItem />
            </div>
          </PermissionWrapper>

          {isFetching && (
            <div className="text-center">
              <Spinner style={{ color: `${themeStatus}` }} />
            </div>
          )}
        </>
      ) : (
        <ComponentSpinner />
      )}
    </>
  );
};

export default HomeLearner;
